// src/pages/DMCA.jsx
import React, { useState } from "react";
import { PageSEO } from "../hooks/useSEO";
import "../styles/styles.css";

const DMCA = () => {
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const f = e.target;
    const body = `
NOTIFICACIÓN DMCA / COPYRIGHT

Obra afectada: ${f.work.value}
URL en AIVEO: ${f.url.value}
Descripción: ${f.description.value}

Declaración:
- Soy el titular de derechos o actúo en su nombre.
- Creo de buena fe que el uso no está autorizado.
- La información es exacta bajo pena de perjurio.

Nombre: ${f.name.value}
Email: ${f.email.value}
    `.trim();
    window.location.href = `mailto:aiveoaicinema@gmail.com?subject=[DMCA] Notificación de infracción&body=${encodeURIComponent(body)}`;
    setSent(true);
  };

  return (
    <div className="legal-page">
      <PageSEO
        title="Copyright y DMCA"
        description="Canal de notificación de contenido con derechos de autor para AIVEO. Política de retirada y contacto legal."
        url="/dmca"
      />
      <div className="legal-container">

        <div className="legal-hero">
          <h1>Copyright y DMCA</h1>
          <p className="legal-lead">
            AIVEO respeta los derechos de propiedad intelectual. Si crees que algún contenido publicado en nuestra plataforma infringe tus derechos de autor, puedes notificárnoslo a través de este canal.
          </p>
        </div>

        <section className="legal-section">
          <h2>1. Política de contenido generado con IA</h2>
          <p>
            Todo el contenido publicado en AIVEO es generado o asistido por inteligencia artificial bajo supervisión editorial humana. AIVEO se compromete a no publicar contenido que reproduzca directamente obras protegidas por derechos de autor sin autorización.
          </p>
          <p>
            Si detectas que algún contenido de AIVEO replica sustancialmente una obra protegida — tramas, personajes, diálogos, música, imágenes o cualquier otro elemento protegible — puedes presentar una notificación formal usando el formulario a continuación.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Cómo presentar una notificación (DMCA / LSSI)</h2>
          <p>
            Para presentar una notificación válida de infracción de derechos de autor, tu comunicación debe incluir:
          </p>
          <ul className="legal-list">
            <li>Identificación de la obra protegida que consideras infringida.</li>
            <li>URL exacta del contenido en AIVEO que consideras infractor.</li>
            <li>Descripción detallada de la supuesta infracción.</li>
            <li>Tu nombre completo, dirección de email y, si procede, razón social.</li>
            <li>Declaración de buena fe: que crees razonablemente que el uso no está autorizado por el titular de derechos.</li>
            <li>Declaración de exactitud: que la información proporcionada es correcta y, si actúas en nombre de otro, que tienes autorización para hacerlo.</li>
          </ul>
          <p>
            Las notificaciones que no incluyan estos elementos pueden no ser atendidas. El envío de notificaciones falsas puede acarrear responsabilidad legal.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Proceso de revisión y retirada</h2>
          <p>
            Tras recibir una notificación válida, AIVEO se compromete a:
          </p>
          <ul className="legal-list">
            <li>Acusar recibo en un plazo de <strong>5 días hábiles</strong>.</li>
            <li>Revisar el contenido señalado y tomar una decisión en un plazo de <strong>15 días hábiles</strong>.</li>
            <li>Retirar o deshabilitar el acceso al contenido si se confirma la infracción.</li>
            <li>Notificar al reclamante el resultado de la revisión.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Política de infractores reincidentes</h2>
          <p>
            AIVEO adopta una política de <em>zero-tolerance</em> hacia la infracción reiterada de derechos de autor. Las cuentas de creadores o usuarios que acumulen notificaciones fundadas podrán ser suspendidas o eliminadas permanentemente.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Contacto legal directo</h2>
          <p>
            Para notificaciones urgentes o consultas legales, puedes escribir directamente a <a href="mailto:aiveoaicinema@gmail.com">aiveoaicinema@gmail.com</a> con el asunto <strong>[DMCA]</strong>.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Formulario de notificación</h2>
          {sent ? (
            <div className="contact-success">
              <span className="contact-success-icon">✓</span>
              <strong>Tu cliente de email debería haberse abierto con la notificación pre-rellenada.</strong>
              <p>Si no, escríbenos directamente a <a href="mailto:aiveoaicinema@gmail.com">aiveoaicinema@gmail.com</a> con el asunto [DMCA].</p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-field">
                <label htmlFor="dmca-work">Obra afectada *</label>
                <input id="dmca-work" name="work" type="text" required placeholder="Título de la obra original protegida" />
              </div>
              <div className="contact-field">
                <label htmlFor="dmca-url">URL del contenido en AIVEO *</label>
                <input id="dmca-url" name="url" type="url" required placeholder="https://www.aiveo.net/series/..." />
              </div>
              <div className="contact-field">
                <label htmlFor="dmca-desc">Descripción de la infracción *</label>
                <textarea id="dmca-desc" name="description" rows="4" required placeholder="Describe de qué forma el contenido infringe tus derechos..." />
              </div>
              <div className="contact-form-row">
                <div className="contact-field">
                  <label htmlFor="dmca-name">Nombre completo *</label>
                  <input id="dmca-name" name="name" type="text" required />
                </div>
                <div className="contact-field">
                  <label htmlFor="dmca-email">Email de contacto *</label>
                  <input id="dmca-email" name="email" type="email" required />
                </div>
              </div>
              <p style={{ fontSize: "0.8rem", color: "var(--color-text-secondary)", marginBottom: "0.5rem" }}>
                Al enviar, declaro que la información es correcta y que soy el titular o actúo con autorización del titular de los derechos afectados.
              </p>
              <button type="submit" className="btn-primary">Enviar notificación</button>
            </form>
          )}
        </section>

      </div>
    </div>
  );
};

export default DMCA;
